import { onCleanup as i } from "solid-js";
function r(o, c) {
  const n = (e) => {
    var t;
    return !o.contains(e.target) && ((t = c(e)) == null ? void 0 : t(e));
  };
  document.body.addEventListener("click", n), i(() => document.body.removeEventListener("click", n));
}
export {
  r as clickOutsideSJ
};
